import { render, staticRenderFns } from "./PopUpRequestDetail.vue?vue&type=template&id=f20e4a64&"
import script from "./PopUpRequestDetail.vue?vue&type=script&lang=js&"
export * from "./PopUpRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f20e4a64')) {
      api.createRecord('f20e4a64', component.options)
    } else {
      api.reload('f20e4a64', component.options)
    }
    module.hot.accept("./PopUpRequestDetail.vue?vue&type=template&id=f20e4a64&", function () {
      api.rerender('f20e4a64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/materialsRequests/vistas/modals/PopUpRequestDetail.vue"
export default component.exports